import React from 'react';

export const renderFlag = (lang, options = {}) => {
  const { size = '20px' } = options;
  if (!lang || !lang.flagImage) return null;
  
  return (
    <span
      style={{
        fontSize: size,
        // Font này sẽ lấy từ link bạn vừa thêm ở index.html
        fontFamily: '"Noto Color Emoji", sans-serif', 
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: '1',
        verticalAlign: 'middle',
        cursor: 'pointer'
      }}
    >
      {lang.flagImage}
    </span>
  );
};


/**
 * Hàm tiện ích để render lá cờ linh hoạt
 * @param {Object} lang - Object ngôn ngữ (chứa flagImage, name, code)
 * @param {Object} options - Các tùy chỉnh thêm (size, className)
 */
// export const renderFlag = (lang, options = {}) => {
//   const { size = '20px', className = '' } = options;

//   if (!lang) return <span style={{ fontSize: size }}>🌐</span>;

//   const { flagImage, name, code } = lang;

//   // 1. Kiểm tra nếu flagImage là một URL (ảnh từ server hoặc flagcdn)
//   const isUrl = flagImage && (flagImage.startsWith('http') || flagImage.startsWith('/') || flagImage.includes('.png') || flagImage.includes('.svg'));

//   if (isUrl) {
//     return (
//       <img
//         src={flagImage}
//         alt={name || code}
//         className={className}
//         style={{
//           width: size,
//           height: 'auto',
//           aspectRatio: '4/3',
//           objectFit: 'cover',
//           borderRadius: '2px',
//           display: 'inline-block',
//           verticalAlign: 'middle'
//         }}
//         // Fallback nếu link ảnh từ API bị lỗi
//         onError={(e) => {
//           e.target.onerror = null;
//           e.target.src = `https://flagcdn.com/w40/${code === 'en' ? 'gb' : code}.png`;
//         }}
//       />
//     );
//   }

//   // 2. Nếu là Emoji (ví dụ: 🇻🇳, 🇬🇧)
//   // Thêm font-family chuẩn để Windows hiển thị được cờ thay vì chữ cái (nếu đã cài font)
//   return (
//     <span
//       className={className}
//       style={{
//         fontSize: size,
//         lineHeight: '1',
//         display: 'inline-block',
//         verticalAlign: 'middle',
//         fontFamily: '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", "Segoe UI Symbol", sans-serif'
//       }}
//       title={name}
//     >
//       {flagImage || '🏳️'}
//     </span>
//   );
// };


// export const renderFlag = (lang, options = {}) => {
//   const { size = '20px' } = options;
//   if (!lang) return null;

//   // Sử dụng FlagCDN để lấy ảnh PNG/SVG dựa trên code (vi, en, jp, kr)
//   // Lưu ý: Tiếng Anh thường dùng cờ Anh (gb)
//   const countryCode = lang.code === 'en' ? 'gb' : lang.code;
//   const flagUrl = `https://flagcdn.com/w40/${countryCode.toLowerCase()}.png`;

//   return (
//     <img
//       src={flagUrl}
//       alt={lang.name}
//       style={{
//         width: size,
//         height: 'auto',
//         borderRadius: '2px',
//         display: 'inline-block',
//         verticalAlign: 'middle',
//         objectFit: 'contain'
//       }}
//       onError={(e) => {
//         e.target.src = 'https://flagcdn.com/w40/un.png'; // Cờ dự phòng nếu lỗi
//       }}
//     />
//   );
// };